// Updated: /src/API/UserProfileApi/GetUserProfile.ts
import { toast } from 'react-toastify';
import { fetchWithToken } from '../../apiauth/apiUtils';
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export interface UserProfile {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  azureToken: string;
  roleId: number;
  roleName: string;
  createdDate: string;
  updatedDate: string;
  status: string | null;
}

export const getUserProfile = async ( t: (key: string) => string): Promise<UserProfile> => {
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetchWithToken(
      `${baseUrl}/api/User/GetUserProfile`,
      {
        method: 'GET',
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`);
    }

    const data: UserProfile = await response.json();
    return data;
  } catch (error) {
    // console.error('Error fetching user profile:', error);
    toast.error(t("userProfileError"));
    throw error;
  }
};
